import {validatePath} from './';

export const getPathWithSearch = (history, search) => {
  const path = validatePath(history.location.pathname);
  return `${path}?search=${search}`;
};

export const isValueValid = value => {
  return value !== undefined && value.replace(/ /g, '').length !== 0;
};

export const stripSearch = (value?): string => {
  if (!value) {
    return '';
  }
  const query: any = {};
  value.replace('?', '').split('&').forEach(item => {
    const params = item.split('=');
    query[params[0]] = params[1];
  });
  return query.search ? query.search : '';
};

export const findSearchTerms = (history, storeSearch?: string) => {
  let searchTerms = storeSearch;
  if (!searchTerms) {
    searchTerms = stripSearch(history.location.search);
  }

  return searchTerms;
};
